import React, { useEffect, useRef, useState } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Text, View, ScrollView, Image } from 'react-native'
import { request_get_wise } from '../../services/schedule.services'
import { Loader } from '../customUtils/Components/Loader'
import { Content, Wise } from '../../services/interfaces/schedule.interface/schedule.getwise.interface'
import theme from '../../../theme'
import { StoreFormItem } from './StoreFormItem'
import { FormView } from './ExecutionView'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { schedulesServices } from '../../../database/schedules.database'
import { getOrCreateFormDayUniqueId } from '../../utils/formDayUniqueIdStore'
import { useNavigation } from '@react-navigation/native'
import styles from './WiseScreenStyles'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FormContentsModel } from './models/StoreDetailModel'
import { eventEmitter, validateConnectionNetwork } from '../../utils/functions.utils'
import { RetryComponent } from './components/RetryComponent'
import { useFormView } from './hooks/useFormView'

export const WiseScreen = React.memo(() => {
    const [formsData, setformsData] = useState<Wise[] | []>([])
    const [isLoading, setIsLoading] = useState(true)
    const [selectedForm, setForm] = useState<Wise>()
    //console.log('🚀 ~ WiseScreen ~ selectedForm:', selectedForm)
    const [formType, setFormType] = useState(0)
    const [formTypeObj, setFormTypeObj] = useState(null)
    // const [formType, setFormType] = useState(0)
    const [formContent, setContents] = useState<Content[]>([])
    const { languageFile } = getLanguage()
    const formsRef = useRef(formsData)
    const navigation = useNavigation()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [reloadHideShowData, setReloadHideShowData] = useState(false)
    const [modalRetry, setModalRetry] = useState(false)
    const messageLoaderForms = 'Cargando formularios...'
    const [formReloadKey, setFormReloadKey] = useState(0)
    const { sendFormsPending } = useFormView({})
    useEffect(() => {
        fetchGetWise()
    }, [])

    useEffect(() => {
        formsRef.current = formsData
    }, [formsData])

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            if (formsRef.current.length > 0) {
                const type = formsRef.current[0]?.type_form?.type ?? 0

                setFormType(type)
                setContents(formsRef.current[0].contents ?? [])
                setFormTypeObj(formsRef.current[0]?.type_form)
                setForm(formsRef.current[0])
            }
        })

        return unsubscribe
    }, [navigation])

    const fetchGetWise = async () => {
        try {
            setModalRetry(false)

            const hasTextLoop = false
            eventEmitter.emit('starGeneralLoaderCustom', messageLoaderForms, null, null, hasTextLoop) //

            const hasConnection = await validateConnectionNetwork()

            if (hasConnection) {
                sendFormsPending()
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''

                request_get_wise({ authToken })
                    .then((res) => {
                        let wise = res.single.wise
                        if (wise.length === 0) {
                            setIsLoading(false)
                            eventEmitter.emit('endGeneralLoaderCustom')
                            setModalRetry(true)
                            return
                        }
                        let newContents = wise[0].contents.map((content) => {
                            if (content.status === 3) {
                                return {
                                    ...content,
                                    hideQuestion: true,
                                }
                            }
                            return content
                        })
                        wise[0].contents = newContents
                        setformsData(wise)

                        if (formType === 0 && res.single.wise && res.single.wise.length > 0) {
                            setFormType(wise[0]['type_form']['type'] ?? 0)
                            setFormTypeObj(wise[0]['type_form'])
                            setContents(wise[0].contents ?? [])
                            // console.log('seteo wise en 83', wise[0].contents[0])
                            setForm(wise[0])
                        }

                        for (const form of wise) {
                            try {
                                schedulesServices.addForm(form, true)
                            } catch (error) {
                                console.error('Error adding FORM:', error)
                            }
                        }

                        setIsLoading(false)
                    })
                    .finally(() => setIsLoading(false))
                    .catch(() => {
                        getWiseLocal()
                    })
            } else {
                await getWiseLocal()
            }
        } catch (error) {
            console.error('fetchGetWise: ', error)
        } finally {
            setTimeout(() => {
                eventEmitter.emit('endGeneralLoaderCustom')
            }, 3000)
        }
    }

    const getWiseLocal = async () => {
        try {
            const forms_wise = await schedulesServices.getFormsWise()
            let wise = forms_wise

            if (wise.length === 0) {
                setIsLoading(false)
                eventEmitter.emit('endGeneralLoaderCustom')
                setModalRetry(true)
                return
            }
            let newContents = wise[0].contents.map((content) => {
                if (content.status === 3) {
                    return {
                        ...content,
                        hideQuestion: true,
                    }
                }
                return content
            })
            wise[0].contents = newContents
            if (formType === 0 && forms_wise && forms_wise.length > 0) {
                setFormType(wise[0]['type_form']['type'] ?? 0)
                setFormTypeObj(wise[0]['type_form'])
                setContents(wise[0].contents ?? [])
                console.log('seteo wise en 126', wise[0].contents[0])
                setForm(wise[0])
            }
            setformsData(wise)
            setIsLoading(false)
        } catch (error) {
            console.error('getWiseLocal: error: ', error)
        } finally {
            setIsLoading(false)
            eventEmitter.emit('endGeneralLoaderCustom')
        }
    }

    const onClickForm = (index: number, forceReload = false) => {
        if (selectedForm != null && selectedForm._id === formsData[index]._id && !forceReload) {
            return
        }
        const type = formsData[index]?.type_form?.type ?? 0
        setFormType(type)
        setFormTypeObj(formsData[index]?.type_form)
        let newContents = formsData[index].contents.map((content) => {
            if (content.status === 3) {
                return {
                    ...content,
                    hideQuestion: true,
                }
            }
            return content
        })
        // setContents(formsData[index].contents ?? [])
        setContents(newContents ?? [])
        setForm(formsData[index])
    }

    const hideOrShow = (hide?: string[], show?: string[], data?: FormContentsModel[]) => {
        // console.log('====================================')
        // console.log('estoy en el hideOrShow ', data.length)
        // console.log('====================================')
        // console.log('Debería ocultar estos', hide)
        // console.log('Debería mostrar estos', show)

        let dataMap = data && data.length > 0 ? data : formContent

        const updatedFormContent = dataMap.map((question) => {
            if (hide && hide.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: true,
                }
            }
            if (show && show.includes(question._id)) {
                return {
                    ...question,
                    hideQuestion: false,
                }
            }
            return question
        })

        setContents(updatedFormContent)
        // console.log('seteo wise en 180', updatedFormContent[0])
        setReloadHideShowData(!reloadHideShowData)
    }

    const clearRegisterDatabaseLocal = async (type = null) => {
        console.log('🚀 ~ clearRegisterDatabaseLocal ~ type:', type)

        const index = getIndexForm(selectedForm._id)

        if (type == 'pending') {
            // Caso: hay envío pendiente, solo recargar UI
            onClickForm(index, true) //setear setContents con formsData
        } else if (type == 'reload') {
            console.log('📝 WISE: Forzando remount para crear nuevo registro limpio')
            setFormReloadKey((prev) => prev + 1)
            onClickForm(index, true)
            console.log('✅ WISE: Nuevo registro creado, formulario limpio')
        } else {
            try {
                const dayId = getOrCreateFormDayUniqueId(selectedForm._id, 'wise', null)
                await schedulesServices.deleteFormAnswer('wise', selectedForm._id, null, dayId)
            } catch (err) {
                console.log('ℹ️ WISE: no se pudo eliminar registro previo:', err)
            }
            onClickForm(index, true)
        }
    }

    const getIndexForm = (form_id: string) => {
        const index = formsData.findIndex((form: Wise) => form._id === form_id)
        return index === -1 ? 0 : index
    }

    return (
        <>
            {isLoading ? (
                <View style={styles.container}>
                    <Loader />
                </View>
            ) : modalRetry ? (
                <RetryComponent onRefresh={fetchGetWise} textButton='Reintentar' title='No pudimos cargar los formularios' />
            ) : (
                formsData.length > 0 && (
                    <View style={styles.container}>
                        <View style={styles.containerFilters}>
                            <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styles.scrollView}>
                                <View style={styles.containerFormItem}>
                                    {formsData.map((form, index) => {
                                        const isSelected = selectedForm === form
                                        const image = isSelected ? form?.icon_check : form?.icon

                                        return (
                                            <StoreFormItem
                                                key={form?._id + index}
                                                name={form?.name_form}
                                                image={image}
                                                index={index}
                                                onClickItem={onClickForm}
                                                isSelected={isSelected}
                                            />
                                        )
                                    })}
                                </View>
                            </ScrollView>
                        </View>

                        {(() => {
                            switch (formType) {
                                case 19:
                                case 13:
                                    // return formContent.length > 0 && <FormView formContent={formContent} hideOrShow={hideOrShow} form_id={selectedForm?._id} />
                                    return (
                                        <>
                                            {formContent.length > 0 && (
                                                <FormView
                                                    key={`${selectedForm?._id}-${formReloadKey}`}
                                                    formContent={formContent}
                                                    hideOrShow={hideOrShow}
                                                    form_id={selectedForm?._id}
                                                    schedule_id={'wise'}
                                                    repeat={selectedForm?.repeat}
                                                    progress={selectedForm?.progress}
                                                    totalScore={selectedForm?.totalScore}
                                                    clearRegisterDatabaseLocal={clearRegisterDatabaseLocal}
                                                    hasFinishSheet={true}
                                                    reloadHideShowData={reloadHideShowData}
                                                    tags={[]}
                                                    onClickTag={() => {}}
                                                    formType={formType}
                                                    name_form={selectedForm?.name_form}
                                                    formTypeObj={formTypeObj}
                                                    // getStatusForm={getStatusForm}
                                                />
                                            )}
                                        </>
                                    )
                                default:
                                    return (
                                        <>
                                            <View style={styles.containerNoMessage}>
                                                <Image style={styles.imageNoMessage} source={require('../../../assets/noFormSelected.png')} />
                                                <Text style={styles.titleNoMessage}>{languageFile.select_form}</Text>
                                                <Text style={styles.descriptionNoMessage}>{languageFile.select_one_form}</Text>
                                            </View>
                                        </>
                                    )
                            }
                        })()}
                    </View>
                )
            )}
        </>
    )
})
